import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const UserProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default UserProtectedRoute;
